import qs from 'qs'

export default function (obj: { [key in string]: string | number }) {
  const params = qs.stringify(obj, {
    skipNulls: true,
    filter: (_, value) => value || undefined,
  })
  return qs.parse(params)
}
